import React, {useRef} from 'react';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import {Box, Card, CardContent, Tooltip, IconButton} from '@mui/material';
import Info from '@mui/icons-material/Info';
import {COLORS, EXPORTING} from '@/utils/constants';
import {getIndicators} from '@/containers/FdcMilanoLogbook/Charts/VolunteersActivities/calculations';
import {getCheckpoints} from '@/containers/FdcMilanoLogbook/Charts/VolunteersActivities/checkpointCalculations';

interface IVolunteersActivitiesProps {
    registerRecordSubmissions: any[],
    checkpoints: any[],
}

const VolunteersActivities = ({registerRecordSubmissions, checkpoints}: IVolunteersActivitiesProps) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);

    return (
        <Box>
            <Box>
                <Box className='section-title'>
                    <Box>
                        I. INTENSITA’ DELLE ATTIVITA’ DEI VOLONTARI
                    </Box>
                    <Tooltip
                        title={<>
                            Il visual mostra:
                            <li> il confronto fra il numero di volontari coinvolti nel progetto che hanno svolto almeno
                                30
                                ore di attività di volontariato e il corrispondente valore atteso</li>
                            <li> il valore medio del tempo di coinvolgimento dei volontari nel progetto</li>
                            I valori effettivi sono ottenuti grazie alla “Scheda di rilevazione delle attività
                            individuali svolte settimanalmente dai volontari”. I valori attesi fanno riferimento al
                            documento riepilogativo KPI di progetto (75 volontari coinvolti).
                        </>}
                    >
                        <IconButton>
                            <Info fontSize='small'/>
                        </IconButton>
                    </Tooltip>
                </Box>
                <Card>
                    <CardContent>
                        <HighchartsReact
                            highcharts={Highcharts}
                            options={{
                                chart: {
                                    height: 400,
                                    type: 'column',
                                    style: {
                                        fontFamily: 'Rubik, sans-serif'
                                    },
                                    backgroundColor: '#fafafa'
                                },
                                title: {
                                    text: '',
                                },
                                legend: {
                                    enabled: false
                                },
                                xAxis: {
                                    categories: [
                                        'Numero di volontari effettivamente coinvolti nel progetto che hanno svolto almeno 30 ore di attività di volontariato',
                                        'Numero di volontari coinvolti nel progetto',
                                        'Durata media della permanenza dei volontari nel progetto (in mesi)'
                                    ]
                                },
                                yAxis: {
                                    title: {
                                        text: '',
                                    },
                                },
                                tooltip: {
                                    formatter: function () {
                                        const formater = (this as any);
                                        const name = formater.x;
                                        const value = formater.y;

                                        return `${name}: ${value}`;
                                    },
                                },
                                series: [
                                    {
                                        color: COLORS.blue,
                                        name: 'Permanenza dei volontari nel progetto',
                                        data: [
                                            getIndicators(registerRecordSubmissions),
                                            75,
                                            getCheckpoints(registerRecordSubmissions, checkpoints)
                                        ]
                                    },
                                ],
                                exporting: EXPORTING,
                            }}
                            ref={chartComponentRef}
                        />
                    </CardContent>
                </Card>
            </Box>
        </Box>
    )
}

export default VolunteersActivities;